import React from "react";
import { useContext } from "react";
import UserManagement from "./UserManagement";
import AdminApproval from "./AdminApproval";
import GenerateInviteForm from "../forms/GenerateInviteForm";
import ArchiveHealthCard from "./ArchiveHealthCard";
import UserContext from "./UserContext";
import "./UserConfig.css";

const UserConfig = () => {
    const { userDetail } = useContext(UserContext);
    const roleId = Number(userDetail?.roleId || 0);

    if (!userDetail) {
        return (
            <section className="page-scroll">
                <div className="page-scroll-inner admin-config-page">
                    <h2>User Configuration</h2>
                    <p>Loading user permissions...</p>
                </div>
            </section>
        );
    }

    if (roleId < 3) {
        return (
            <section className="page-scroll">
                <div className="page-scroll-inner admin-config-page">
                    <h2>User Configuration</h2>
                    <p>Manager access required.</p>
                </div>
            </section>
        );
    }

    return (
        <section className="page-scroll">
            <div className="page-scroll-inner admin-config-page">
                <h2>User Configuration</h2>
                <div className="admin-section">
                    <h3>Update Access Roles</h3>
                    <UserManagement />
                </div>
                <div className="admin-section">
                    <h3>New User Registration Approvals</h3>
                    <AdminApproval />
                </div>
                <div className="admin-section">
                    <h3>Generate Invite</h3>
                    <GenerateInviteForm />
                </div>
                <div className="admin-section admin-section-archive-health">
                    <ArchiveHealthCard />
                </div>
            </div>
        </section>
    );
};

export default UserConfig;
